module.exports = __webpack_public_path__ + "74220e917bdbe5a6545f763dd075afdc.svg";